import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";
import { namesList as drivers } from "sources/books/drivers";
import { numbersList as trailers } from "sources/books/trailers";
import { numbersList as trucks } from "sources/books/trucks";

const config = {
    shiftDriverId: {
        label: "Водитель",
        inputProps: { name: "shiftDriverId" },
        url: drivers,
        filterPropName: "fullName",
        propName: "fullName",
        placeholder: "Если меняется водитель — укажите нового водителя",
        menuPortalTarget: document.body,
    },
    shiftSecondaryDriverId: {
        label: "Второй водитель",
        inputProps: { name: "shiftSecondaryDriverId" },
        url: drivers,
        filterPropName: "fullName",
        propName: "fullName",
        placeholder: "Если меняется водитель — укажите нового водителя",
        menuPortalTarget: document.body,
    },
    shouldClearSecondaryDriver: {
        label: "Удалить второго водителя",
        inputProps: { name: "shouldClearSecondaryDriver" },
        checkbox: true,
        fieldBeforeLabel: true,
        labelWrapper: "col-auto col-form-label col-form-label-sm pl-0",
        fieldWrapper: "col-auto offset-sm-4 offset-md-3 d-flex align-items-center",
    },
    shiftCarId: {
        label: "Машина",
        inputProps: { name: "shiftCarId" },
        url: trucks,
        propName: "number",
        placeholder: "Если меняется машина — укажите новую машину",
        menuPortalTarget: document.body,
    },
    shiftTrailerId: {
        label: "Прицеп",
        inputProps: { name: "shiftTrailerId" },
        url: trailers,
        propName: "number",
        placeholder: "Если меняется прицеп — укажите новый прицеп",
        menuPortalTarget: document.body,
    },
    planEnterDate: {
        label: "Плановая дата въезда",
        inPortal: true,
        validators: [requiredField],
        required: true,
        inputProps: { name: "planEnterDate" },
    },
    planLeaveDate: {
        label: "Плановая дата выезда",
        inPortal: true,
        inputProps: { name: "planLeaveDate" },
    },
    shiftCar: {},
    mapObject: {},
    order: {},
    parallelBidId: {},
    id: {},
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
